module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '\r\n<div class="progress-wrap">\r\n    <div class="detail-price">\r\n        <div class="progress">\r\n            <div class="progress-bar shine">\r\n                <span><a class="circular"></a></span>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/common/progressBar/progressBar.ejs
// module id = 115
// module chunks = 3 5 6 9